import { render, staticRenderFns } from "./addAttrValues.vue?vue&type=template&id=472b6f3d&"
import script from "./addAttrValues.vue?vue&type=script&lang=js&"
export * from "./addAttrValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports